
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingScreenProps {
  isVisible: boolean;
}

const LoadingScreen = ({ isVisible }: LoadingScreenProps) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const { t } = useTranslation();
  const loadingMessages = t('loading.messages', { returnObjects: true }) as string[];

  useEffect(() => {
    if (!isVisible) {
      setMessageIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setMessageIndex(prev => {
        if (prev < loadingMessages.length - 1) {
          return prev + 1;
        }
        return prev;
      });
    }, 2500);

    return () => clearInterval(interval);
  }, [isVisible, loadingMessages.length]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-[#0A1628] via-[#0F1F3A] to-[#0A1628]">
      <div className="max-w-md w-full px-6 text-center space-y-8">
        {/* Logo ou ícone */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-20 h-20 rounded-full border-4 border-[#FFD700]/20 border-t-[#FFD700] animate-spin"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="ri-flight-takeoff-line text-3xl text-[#FFD700]"></i>
            </div>
          </div>
        </div>

        {/* Título */}
        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl font-bold text-white">
            {t('loading.title')}
          </h2>
          <p className="text-white/90 text-sm">
            {t('loading.subtitle')}
          </p>
        </div>

        {/* Mensagem dinâmica */}
        <div className="min-h-[60px] flex items-center justify-center">
          <p className="text-[#FFD700] text-base font-medium animate-pulse">
            {loadingMessages[messageIndex]}
          </p>
        </div>

        {/* Barra de progresso */}
        <div className="relative h-1 bg-white/5 rounded-full overflow-hidden">
          <div 
            className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#FFD700] to-[#FFA500] rounded-full transition-all duration-1000 ease-out"
            style={{ 
              width: `${((messageIndex + 1) / loadingMessages.length) * 100}%` 
            }}
          />
        </div>

        {/* Dica */}
        <p className="text-white/90 text-xs">
          {t('loading.tip')}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
